<template>
    <div>
        <!-- SOURCE -->
        <K2Button @onclick="downloadPDF">Download</K2Button>
        <div id="printMe" ref="printcontent" class="printMe">

            <ActivityPreviewforPrint :printPreview="printPreview"/>

        </div>

        <!-- OUTPUT -->
    </div>
</template>

<script>
  import uiVariable from "../../../config/uiVariable";
  import Cookies from "js-cookie";
  import { lang } from "../../../locale";
  import ActivityPreviewforPrint from "./activityPreviewforPrint";
  import DataSource from "../../../data/datasource";
  import pdf from "vue-pdf";
  import K2Button from "../../../uiComponents/k2Button/k2Button";
  import "./KaiTi-normal";

  const { jsPDF } = require("jspdf");

  export default {
    name: "activityDownload",
    components: { K2Button, ActivityPreviewforPrint },
    props: [""],
    data() {
      return {
        uiVariable: uiVariable,
        filterFromDate: "",
        filterToDate: "",
        postList: null,
        postType: "Moment",
        printPreview: null
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      lang,
      async init() {
        await this.loadPosts();
      },
      async loadPosts() {
        console.log("loadPostss");
        this.$vs.loading();
        let userRole;
        $("html, body").animate({ scrollTop: 0 }, "fast");
        this.bool_ShowRefresh = false;
        this.isParent = Cookies.get("userTypeSession");
        this.postList = [];

        if (this.isParent === "Parent") {
          userRole = "Parent";
        } else if (this.isParent === "Principal" || this.isParent === "Course Leader") {
          userRole = "Staff";
        } else {
          userRole = "Teacher";
        }

        const response = await DataSource.shared.getStaffActivityPostAllByClass(
          99999, null, this.postType, "Portfolio", "All", this.postType, null, this.filterFromDate, this.filterToDate, null, "", userRole,
          [], [], [], ["STU202200182921"], [], null);
        console.log(response);

        if (response) {
          if (response.code === "88") {
            window.location.replace("/");
          } else if (response.Table) {
            if (response.Table && response.Table.length > 0) {
              this.postList.push.apply(this.postList, response.Table);
              this.postList.forEach(d => {
                let found = d.PostTagLists.find(d => d.IsAllLevel === true);
                d.show = !found;
              });
            }
          }
        }
        this.printPreview = this.postList[0];
        console.log("printPreview", this.printPreview);
        this.handlePostItem();
        this.$vs.loading.close();
      },
      handlePostItem() {
        try {

          this.postList && this.postList.forEach(post => {
            // get post files
            if (post.PostItems) {
              post.postFiles = post.PostItems;
              post.postFiles.forEach(file => {
                file.numPages = undefined;

                if (file.PostItemFileExt.toLowerCase() === ".pdf") {
                  let src = pdf.createLoadingTask(file.FilePath);
                  file.pageOfSrc = src;
                  src.promise.then(pdf => {
                    file.numPages = pdf.numPages;
                  });
                }
                file.oriFilePath = file.FilePath;

                if (this.isImageByExt(file)) {
                  let filename = file.PostItemID + file.PostItemFileExt;
                  this.urltoFile(file.FilePath, filename, file.PostItemFileType).then((blobFile) => {
                    let url = window.URL.createObjectURL(blobFile);
                    file.FilePath = url;
                  }).finally(() => {
                  });
                }

                if (this.isVideo(file)) {
                  let filename = file.PostItemID + file.PostItemFileExt;
                  this.urltoFile(file.FilePath, filename, file.PostItemFileType).then((blobFile) => {
                    let url = window.URL.createObjectURL(blobFile);
                    file.blobFilePath = url;
                  }).finally(() => {
                  });
                }
              });
            }

            // get post student
            if (post.PostTagLists) {
              let isSchool = post.PostTagLists.find(d => d.IsAllLevel === true);
              if (!isSchool) {
                if (post.PostTagLists[0].PostTagClassID) {
                  post.classList = post.PostTagLists;
                } else if (post.PostTagLists[0].PostTagLevelID) {
                  post.levelList = post.PostTagLists;
                } else if (post.PostTagLists[0].PostTagUserID) {
                  post.studentList = post.PostTagLists;
                }
              } else {
                post.school = Cookies.get("userSchoolNameSession");
              }
            }
          });

        } catch (e) {
          console.log(e, "initPost err");
        }
      },
      async downloadPost(index) {
        if(index <= this.postList.length){
          let tempIndex = index || 0;
          this.printPreview = this.postList[tempIndex];
          this.downloadPDF(tempIndex);
          this.downloadPost(index + 1);
        }
      },
      downloadPDF(index) {
        console.log("downloadPDF", this.postList.length);
        let doc = new jsPDF("p", "px", "a3", true);
        doc.setFont("KaiTi");
        let element = document.getElementById("printMe");
        doc.html(element, {
          x: 40,
          y: 40,
          callback: function(doc) {
            doc.save("downloadFeed.pdf");
              console.log("downloadPostaaa");
          }
        });

      },
      isImageByExt(obj_File) {
        let ext = String(obj_File.PostItemFileExt).toUpperCase();
        let isImage = false;

        switch (ext) {
          case ".PNG":
          case ".JPG":
          case ".BMP":
          case ".GIF":
          case ".JPEG":
            isImage = true;
            break;
          default:
            isImage = false;
            break;
        }

        return isImage;
      },
      urltoFile(url, filename, mimeType) {
        return (fetch(url)
            .then(function(res) {
              return res.arrayBuffer();
            })
            .then(function(buf) {
              return new File([buf], filename, { type: mimeType });
            })
        );
      },
      isVideo(obj_File) {
        if (obj_File) {
          let ext = String(obj_File.PostItemFileExt).toUpperCase();
          let isVideo = false;

          switch (ext) {
            case ".MP4":
            case ".MOV":
              isVideo = true;
              break;
            default:
              isVideo = false;
              break;
          }

          return isVideo;
        }
      }
    }

  };
</script>